export const offers = state => state.allOffers
export const newshipments = state => state.newshipments
export const myshipments = state => state.myshipments

export const newshipmentscount = state => state.newshipments.filter(shipment => { return !shipment.offer_made }).length
export const openofferscount = state => state.allOffers.filter(offer => { return offer.shipment_status === 'pending' }).length
export const activeshipmentscount = state => state.myshipments.filter(shipment => { return shipment.current_state.state !== 'finalised'}).length

export const currentnewshipment = state => shipmentId => {
  return state.newshipments.find(el => el.id === parseInt(shipmentId))  
}

export const currentmyshipment = state => shipmentId => {
  return state.myshipments.find(el => el.id === parseInt(shipmentId))
}
